// extracted by mini-css-extract-plugin
export default {"Wrap":"RenameModal_Wrap__OOvOP","Mask":"RenameModal_Mask__OPohP","Input":"RenameModal_Input__P4ohz"};